import { render, staticRenderFns } from "./duration.vue?vue&type=template&id=28f4aa9a&"
import script from "./duration.vue?vue&type=script&lang=ts&"
export * from "./duration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports